/**
 * Where to go after signing in. `redirect` arrives in the URL, so anybody can
 * write anything there: only a path inside this app is followed.
 */
export function safeRedirect(target: string | undefined): string {
  if (target === undefined) return "/";
  // "//host" and "/\host" leave the origin; a scheme does too.
  if (!target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) return "/";
  if (target === "/sign-in" || target.startsWith("/sign-in?")) return "/";
  return target;
}
